export const resourcesPage = {
  pageHeading: 'resources',
  guidesAndForms: 'guides_and_forms',
  guidesAndFormsText: 'guides_and_forms_text',
  regulatoryGuidanceId: 'regulatory_guidance',
  usefulGuidesAndFormsId: 'useful_guides_and_forms',
  placingBusinessTitleId: 'placing_business',
  customerInformationId: 'customer_information',
};
